// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2p-button.is-thin.el-button--small,.d2p-button.is-thin.el-button--small.is-round{padding:9px 9px}.d2p-button.is-thin.el-button--mini,.d2p-button.is-thin.el-button--mini.is-round{padding:7px 7px}", ""]);
// Exports
module.exports = exports;
